import React from 'react';

const UsersPage = () => (
  <div>
    <h1>Users Page</h1>
  </div>
);

export default UsersPage;
